<template>
    <div id="appRoot" data-app>
        <template v-if="$route.meta.requires_auth">
            <v-app id="inspire" class="app">
                <app-drawer class="app--drawer"></app-drawer>
                <app-toolbar class="app--toolbar"></app-toolbar>
                <v-content v-show="loading">
                    <v-layout align-center justify-center class="full-height loading-wrapper">
                        <v-progress-circular
                                indeterminate
                                color="primary"
                        ></v-progress-circular>
                    </v-layout>
                </v-content>
                <v-content>
                    <!-- Page Header -->
                    <page-header v-if="$route.meta.breadcrumb"></page-header>
                    <div class="page-wrapper">
                        <transition
                                name="fade"
                                mode="out-in">
                            <router-view :key="$route.fullPath"></router-view>
                        </transition>
                    </div>
                    <!-- App Footer -->
                    <v-footer height="auto" class="white pa-2 app--footer">
                        <v-card flat tile class="flex">
                            <v-card-text class="pa-0">
                                <v-layout row wrap>
                                    <v-flex md4 sm12 xs12 class="text-md-left text-sm-center text-xs-center">
                                        <span class="caption btn-height">&copy;{{ new Date().getFullYear() }} — <strong>JitEvent</strong> — {{$t('app.copy_right')}} <span :class="$vuetify.breakpoint.smAndDown ? 'company-name' : '' ">{{$t('app.company_name')}}</span></span>
                                    </v-flex>
                                    <v-flex md4 sm12 xs12 class="justify-center text-xs-center">
                                        <a class="btn-height" href="https://www.optitable.com/optievent-privacy/" target="_blank">{{$t('form.pp')}}</a>
                                    </v-flex>
                                    <v-flex md4 sm12 xs12 class="text-md-right text-sm-center text-xs-center">
                                        <v-menu
                                                left
                                                offset-y
                                                origin="center center"
                                                transition="scale-transition"
                                        >
                                            <v-btn
                                                    flat
                                                    slot="activator"
                                            >
                                                {{ $t('languages.' + getCurrentLanguage ) }}
                                            </v-btn>
                                            <v-list>
                                                <v-list-tile
                                                        v-for="(language, index) in languages"
                                                        :key="index"
                                                        @click="changeLanguage(language)"
                                                >
                                                    <v-list-tile-title>{{ $t('languages.' + language ) }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-footer>
                </v-content>
                <v-fade-transition>
                    <div v-show="loading_overlay" class="loading-overlay">
                        <div class="loading-dialog">
                            <v-card
                                    color="primary"
                                    dark
                            >
                                <v-card-text>
                                    {{$t('general.processing')}}
                                    <v-progress-linear
                                            indeterminate
                                            color="white"
                                            class="mb-0"
                                    ></v-progress-linear>
                                </v-card-text>
                            </v-card>
                        </div>

                    </div>
                </v-fade-transition>
                <!-- Go to top -->
                <!--<app-fab></app-fab>-->
            </v-app>
        </template>
        <template v-else>
            <transition
                    name="fade"
                    mode="out-in">
                    <router-view :key="$route.fullPath"></router-view>
            </transition>
        </template>
        <confirm-dialog ref="confirm"></confirm-dialog>
        <v-snackbar
                :timeout="snackbar.timeout"
                bottom
                right
                :color="snackbar.color"
                v-model="snackbar.show"
        >
            {{ snackbar.text }}
            <v-btn dark flat @click.native="snackbar.show = false" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    import AppDrawer from '~/components/AppDrawer';
    import AppToolbar from '~/components/AppToolbar';
    import AppFab from '~/components/AppFab';
    import PageHeader from '~/components/PageHeader';
    import ConfirmDialog from '~/components/common/ConfirmDialog';
    import AppEvents from  './event';
    import i18n, {languages} from "~/i18n";
    export default {
        components: {
            AppDrawer,
            AppToolbar,
            AppFab,
            PageHeader,
            ConfirmDialog
        },
        data: () => ({
            permissions: [],
            expanded: true,
            rightDrawer: false,
            snackbar: {
                timeout: 3000,
                show: false,
                text: '',
                color: '',
            },
            languages: languages,
            loading: false,
            loading_overlay: false
        }),
        computed: {
            getCurrentLanguage() {
                return this.$store.state.lang;
            }
        },
        created () {
            AppEvents.forEach(item => {
                this.$on(item.name, item.callback);
            });
            window.getApp = this;
        },
        methods: {
            changeLanguage(language) {
                this.$store.dispatch('setLang', language).then(() => {
                    this.$router.replace({params: {'lang': language}, query: this.$route.query});
                });
            },
        },
        mounted () {
            // init the confirm dialog
            this.$root.$confirm = this.$refs.confirm.open;
        }
    };
</script>

<style lang="stylus" scoped>
    .setting-fab
        top:50%!important
        right:0;
        border-radius:0
    .page-wrapper {
        position relative;
        min-height:calc(100vh - 128px )
    }

    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }
    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
    .full-height {
        height: 100%;
    }
    .loading-wrapper {
        position: fixed;
        top: 0;
        left 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        background-color: white;
    }
</style>

<style>
    * {
        font-family: 'Roboto', sans-serif;
    }

    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        background-color: rgba(0,0,0,0.4);
        transition: opacity 0.5s;
    }

    .loading-dialog {
        width: 300px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .btn-height {
        line-height: 48px;
    }

    .company-name {
        display: inline-block;
        width: 100%;
        border-bottom: 1px solid #444;
    }
</style>